
import React, {useState} from 'react';
import { /*Container, Row, Col, */Tabs, Tab, Button } from 'react-bootstrap';
import './App.css';
import NOxEmissionsElectricityGeneratorsMap from './NOxEmissionsElectricityGeneratorsMap';
import NOxEmissionsElectricityGeneratorsData from './NOxEmissionsElectricityGeneratorsData';

const PAGE_SIZE = 15;
const createPageButtons = (index, setIndex, number_of_records) => {

  return <div style={{textAlign: "center"}}>
            <Button 
              variant="secondary" 
              aria-label="Previous" 
              style={{marginRight: "10px", float: "left"}} 
              disabled={index <= 0} 
              onClick={(e) => setIndex(index - PAGE_SIZE)}>
                Previous
            </Button>
            Page {index / PAGE_SIZE + 1}
            <Button variant="secondary" 
              aria-label="Next" 
              style={{marginRight: "10px", float: "right"}} 
              disabled={index + PAGE_SIZE >= number_of_records}  
              onClick={(e) => setIndex(index + PAGE_SIZE)}>
                &nbsp;&nbsp;Next&nbsp;&nbsp;
              </Button>
  </div>;
};

const numberWithCommas = (x) => {
  if (x.length <= 3) { // 999
    return x;
  }
  if (x.length <= 6) { // 999,999
    return x.substring(0, x.length - 3) + "," + x.substring(x.length - 3, x.length);
  }
  if (x.length <= 9) { // 999,999,999
    //console.log(`x: ${x}`);
    return x.substring(0, x.length - 6) + "," + x.substring(x.length - 6, x.length - 3) + "," + x.substring(x.length - 3, x.length);
  }
  if (x.length <= 12) { // 999,999,999,999
    return x.substring(0, x.length - 9) + "," + x.substring(x.length - 9, x.length - 6) + "," + x.substring(x.length - 6, x.length - 3) + "," + x.substring(x.length - 3, x.length);
  }
  if (x.length <= 15) { // 999,999,999,999,999
    return x.substring(0, x.length - 12) + "," + x.substring(x.length - 12, x.length - 9) + "," + x.substring(x.length - 9, x.length - 6) + "," + x.substring(x.length - 6, x.length - 3) + "," + x.substring(x.length - 3, x.length);
  }
  return x;
};
/*
console.log(numberWithCommas("999"));
console.log(numberWithCommas("999999"));
console.log(numberWithCommas("999999999"));
console.log(numberWithCommas("999999999999"));
console.log(numberWithCommas("999999999999999"));
console.log(numberWithCommas("999999999999999999"));
*/
function App() {
  const [noxEmissionMapTabKey, setNoxEmissionMapTabKey] = useState("chart");
  const [noxEmissionTableIndex, setNoxEmissionTableIndex] = useState(0);
  //const title = "Prevailing wind direction of major NO\u2093 emission sources";
  return <div>
        <Tabs
            id="Nox-Emission-Map-tab"
            style={{fontWeight: "bold"}}
            activeKey={noxEmissionMapTabKey}
            onSelect={key => setNoxEmissionMapTabKey(key)}
          >
            <Tab eventKey="chart" title="Map">
              <NOxEmissionsElectricityGeneratorsMap title={""}/>
            </Tab>
            <Tab eventKey="data" title="Data">
              <div>
                <table>
                  <caption>Prevailing wind direction of major <abbr title="nitrogen oxides">NO{"\u2093"}</abbr> emission sources</caption>
                  <thead> 
                    <tr>
                      <th>Longitude</th>
                      <th>Latitude</th>
                      <th><abbr title="nitrogen oxides">NO{"\u2093"}</abbr> (tonnes)</th>
                    </tr>
                  </thead> 
                  <tbody>
                    {
                      NOxEmissionsElectricityGeneratorsData
                        .filter((item, index) => index >= noxEmissionTableIndex && index < (noxEmissionTableIndex + PAGE_SIZE))
                        .map((item, index) => 
                          <tr key={index}>
                            <td>{item["lng"]}</td>
                            <td>{item["lat"]}</td>
                            <td>{numberWithCommas(item["NOx"].toFixed(0))}</td>
                          </tr>
                        )
                    }
                  </tbody>
                </table>
                {createPageButtons(noxEmissionTableIndex, setNoxEmissionTableIndex, NOxEmissionsElectricityGeneratorsData.length)}
              </div>
            </Tab>
        </Tabs>
  </div>;
}

export default App;
/**
 *     <Container>
      <Row>
        <Col>
        </Col>
      </Row>
    </Container>
 */